import { put } from "redux-saga/effects"
import Cookies from "js-cookie"
import { push } from "connected-react-router"

import api from "apis"

import { setLoginNotification } from "../actions"

import processCredentital from "./register-order/process-credentials"
import responseFailFormActions from "./register-order/response-fail-form-actions"

export default function* registerOrder(actions) {
  // Check if user is logged in or not in order to determine if explicit login
  // is required
  let isLoggedIn = Cookies.get("jwt") !== undefined

  // Clear notification box
  yield put(setLoginNotification(""))
  let values = actions.values
  let isSuccessResponse = processCredentital(actions)
  if (!isSuccessResponse) {
    return false
  }
  let credentials
  // Explicitly login if user is not logged in to fetch and set credentials
  if (!isLoggedIn) {
    credentials = yield api.post("/api/v4/login", actions.values)
  }

  // Construct required params for explicit login/register
  let params = {
    cert_number: values.orderNumber,
    jwt: Cookies.get("jwt") || credentials.jwt,
  }

  // Register order with provided params
  const result = yield api.post("/api/v4/user/register_order", params)
  if (result.ResponseCode == 1) {
    yield put(push("/register/success"))
  }
  //  Unsuccessful response handling
  console.log("Failed register-order", result)
  let setStatus
  let setSubmitting
  if (actions.action && actions.action.setStatus) {
    setStatus = actions.action.setStatus
    setSubmitting = actions.setSubmitting
  }
  let errorMsg
  if (result.ResponseCode == 104) {
    errorMsg = "Login is incorrect. Please try again."
  } else {
    errorMsg = result.ResponseMessage
  }
  let statusMsg = result.ResponseMessage
  return yield responseFailFormActions(
    errorMsg,
    setStatus,
    statusMsg,
    setSubmitting
  )
}
